import FeedbackQuestions from "../../../../contents/docs/cdp/_snippets/feedback-questions.mdx";
import PostHogMaintained from "../../../../contents/docs/cdp/_snippets/posthog-maintained.mdx";
import { IconSparkles } from '@posthog/icons';
import * as React from 'react';
export default {
  FeedbackQuestions,
  PostHogMaintained,
  IconSparkles,
  React
};